"use strict";

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.array.index-of.js");

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.array.is-array.js");

require("core-js/modules/es.symbol.description.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.symbol.iterator.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.array.slice.js");

require("core-js/modules/es.function.name.js");

require("core-js/modules/es.array.from.js");

require("core-js/modules/es.object.define-property.js");

require("core-js/modules/es.array.filter.js");

require("core-js/modules/es.object.get-own-property-descriptor.js");

require("core-js/modules/es.array.for-each.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.object.get-own-property-descriptors.js");

require("core-js/modules/es.object.define-properties.js");

require("core-js/modules/es.object.assign.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.RocheTextField = void 0;

var _react = _interopRequireDefault(require("react"));

var _clsx3 = _interopRequireDefault(require("clsx"));

var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));

var _inputAdornment = _interopRequireDefault(require("../inputAdornment"));

var _core = require("../core");

var _utils = require("../utils");

var _helperText = require("./helper-text.component");

var _textField = require("./text-field.style");

var _CautionFilled = _interopRequireDefault(require("../icons/CautionFilled"));

var _excluded = ["classes", "InputProps", "InputLabelProps", "FormHelperTextProps", "helperText", "errorStartAdornment", "onFocus", "onBlur"],
    _excluded2 = ["adornedStart"],
    _excluded3 = ["counter"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * Text fields let users enter and edit text
 */
var RocheTextField = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var _restProps$inputProps, _clsx, _restProps$inputProps2;

  var classes = props.classes,
      InputProps = props.InputProps,
      InputLabelProps = props.InputLabelProps,
      FormHelperTextProps = props.FormHelperTextProps,
      helperText = props.helperText,
      errorStartAdornment = props.errorStartAdornment,
      onFocus = props.onFocus,
      onBlur = props.onBlur,
      restProps = _objectWithoutProperties(props, _excluded); // Computed values


  var isFilled = restProps.variant === 'filled';
  var hasMaxLength = ((_restProps$inputProps = restProps.inputProps) === null || _restProps$inputProps === void 0 ? void 0 : _restProps$inputProps.maxLength) > 0; // Classes

  var innerInputClasses = (0, _utils.mergeClasses)((isFilled ? _textField.useFilledInputStyles : _textField.useOutlinedInputStyles)(), InputProps === null || InputProps === void 0 ? void 0 : InputProps.classes);

  var startAdornment = /*#__PURE__*/_react["default"].createElement("div", {
    className: "start-adornment"
  }, restProps.error ? errorStartAdornment : InputProps === null || InputProps === void 0 ? void 0 : InputProps.startAdornment);

  var _mergeClasses = (0, _utils.mergeClasses)((0, _textField.useInputLabelStyles)(), InputLabelProps === null || InputLabelProps === void 0 ? void 0 : InputLabelProps.classes),
      customInputLabelAdornedStartClass = _mergeClasses.adornedStart,
      innerInputLabelClasses = _objectWithoutProperties(_mergeClasses, _excluded2);

  var _mergeClasses2 = (0, _utils.mergeClasses)((0, _textField.useFormHelperTextStyles)(), FormHelperTextProps === null || FormHelperTextProps === void 0 ? void 0 : FormHelperTextProps.classes),
      customFormHelperTextCounterClass = _mergeClasses2.counter,
      innerFormHelperTextClasses = _objectWithoutProperties(_mergeClasses2, _excluded3); // State & Handlers


  var _React$useState = _react["default"].useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      hasFocus = _React$useState2[0],
      setHasFocus = _React$useState2[1];

  var handleFocus = function handleFocus(event) {
    setHasFocus(true);

    if (onFocus) {
      onFocus(event);
    }
  };

  var handleBlur = function handleBlur(event) {
    setHasFocus(false);

    if (onBlur) {
      onBlur(event);
    }
  };

  return /*#__PURE__*/_react["default"].createElement(_TextField["default"], _extends({
    ref: ref,
    classes: classes,
    onFocus: handleFocus,
    onBlur: handleBlur,
    InputProps: _objectSpread(_objectSpread({}, InputProps), {}, {
      classes: innerInputClasses,
      startAdornment: startAdornment
    }),
    InputLabelProps: _objectSpread(_objectSpread({}, InputLabelProps), {}, {
      classes: _objectSpread(_objectSpread({}, innerInputLabelClasses), {}, {
        root: (0, _clsx3["default"])(innerInputLabelClasses.root, (_clsx = {}, _defineProperty(_clsx, innerInputLabelClasses.filled, isFilled), _defineProperty(_clsx, innerInputLabelClasses.outlined, !isFilled), _defineProperty(_clsx, customInputLabelAdornedStartClass, Boolean(InputProps === null || InputProps === void 0 ? void 0 : InputProps.startAdornment)), _clsx))
      }),
      shrink: Boolean(props.value) || hasFocus
    }),
    FormHelperTextProps: _objectSpread(_objectSpread({}, FormHelperTextProps), {}, {
      classes: _objectSpread(_objectSpread({}, innerFormHelperTextClasses), {}, {
        root: (0, _clsx3["default"])(innerFormHelperTextClasses.root, _defineProperty({}, customFormHelperTextCounterClass, hasMaxLength))
      })
    }),
    helperText: /*#__PURE__*/_react["default"].createElement(_helperText.HelperText, {
      helperText: helperText,
      hasMaxLength: hasMaxLength,
      maxLength: (_restProps$inputProps2 = restProps.inputProps) === null || _restProps$inputProps2 === void 0 ? void 0 : _restProps$inputProps2.maxLength,
      value: restProps.value,
      required: restProps.required
    })
  }, restProps));
});

exports.RocheTextField = RocheTextField;
RocheTextField.displayName = (0, _core.rochePrefix)('TextField');
RocheTextField.defaultProps = {
  variant: 'filled',
  errorStartAdornment: /*#__PURE__*/_react["default"].createElement(_inputAdornment["default"], {
    position: "start"
  }, /*#__PURE__*/_react["default"].createElement(_CautionFilled["default"], null))
};
var _default = RocheTextField;
exports["default"] = _default;